<div class="empty-state" [class.empty-state--orbit]="appearance === 'orbit'">
  <div class="empty-icon">
    <i [class]="icon"></i>
  </div>
  <h3 class="empty-title">{{ title }}</h3>
  <p class="empty-message">{{ message }}</p>
  <button *ngIf="actionLabel" class="empty-action" (click)="action.emit()">
    <i [class]="actionIcon"></i>
    {{ actionLabel }}
  </button>
</div>
